import { VARIANT } from '@/constants';
import { FormSelect as CommonFormSelect, type FormSelectProps as CommonFormSelectProps } from '@monorepo/common';
import type { FieldValues } from 'react-hook-form';

type FormSelectProps<T extends FieldValues> = Omit<CommonFormSelectProps<T>, 'variant'>;

function FormSelect<T extends FieldValues>(props: FormSelectProps<T>) {
  return <CommonFormSelect {...props} variant={VARIANT} />;
}

export default FormSelect;
